/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'progress': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M4.784 3.097a.47.47 0 00-.638.063l-.057.075a.583.583 0 00.057.696L9.793 10l-5.647 6.069-.057.075a.583.583 0 00.057.696.471.471 0 00.708 0l6-6.454.057-.076a.583.583 0 00-.057-.696l-6-6.454-.07-.063zm7 0a.47.47 0 00-.638.063l-.057.075a.583.583 0 00.057.696L16.793 10l-5.647 6.069-.057.075a.583.583 0 00.057.696.471.471 0 00.708 0l6-6.454.057-.076a.583.583 0 00-.057-.696l-6-6.454-.07-.063z" _fill="#1D3861"/>'
  }
})
